import useWebSocket from 'react-use-websocket';
import { environment, variablesGlobales } from '../configs/variables';
import { useCallback, useEffect, useMemo } from 'react';


export const useWebSocketClient = ({ userId, handler }) => {
    // Determinar la URL del WebSocket en función del entorno
    const wsUrl = useMemo(() => {
        return variablesGlobales.urlServiceWebsocket;
    }, []);

    const { lastMessage, readyState, sendMessage } = useWebSocket(`${wsUrl}?userId=${userId}`, {
        onOpen: () => {
            if (environment !== 'PROD') console.log('Connected to WebSocket');
        },
        shouldReconnect: () => true,
        onMessage: useCallback((message) => {
            const { topic, data } = JSON.parse(message.data);
            if (topic === 'notification') {
                handler[topic](data);
            } else if (topic === 'heartbeat') {
                environment !== 'PROD' && console.log(data);
            }
        }, []),
        onClose: () => {
            if (environment !== 'PROD') console.log('Disconnected');
        },
    });

    useEffect(() => {
        /* if (lastMessage !== null) {
            const { topic, data } = JSON.parse(lastMessage.data);
            if (topic === 'notification') {
                dispatch({ type: 'ADD_NOTIFICATION', notification: data });
            }
        } */
    }, [lastMessage]);

    // Heartbeat para mantener la conexión activa
    useEffect(() => {
        const interval = setInterval(() => {
            if (readyState === 1) {
                sendMessage(JSON.stringify({ topic: 'heartbeat', data: 'ping' }));
            }
        }, 30000); // Enviar cada 30 segundos

        return () => clearInterval(interval); // Limpia el intervalo al desmontar el componente
    }, [readyState, sendMessage]);

    return { lastMessage, readyState };
};
